import React, { useEffect, useState } from 'react';
import axios from '../utils/axios';
import { Box, Link, Stack, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/system';

// Chuông động vàng đẹp mắt
const blinkAnim = keyframes`
  0%, 100% {
    transform: scale(1);
    opacity: 1;
    filter: drop-shadow(0 0 0px #ffca28);
  }
  50% {
    transform: scale(1.18);
    opacity: 0.7;
    filter: drop-shadow(0 0 7px #ffd54f);
  }
`;

const BlinkingIcon = styled('span')({
  animation: `${blinkAnim} 1.25s infinite`,
  fontSize: '19px',
  color: '#ffc107',
  margin: '0 4px',
  verticalAlign: 'middle',
  filter: 'drop-shadow(0 0 2px #ffd54f)',
});

const motionHover = {
  transition: 'all 0.22s cubic-bezier(.4,0,.2,1)',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.29)',
    boxShadow: '0 6px 14px rgba(32,85,255,0.09)',
    transform: 'translateY(-2px) scale(1.012)',
  },
};

export default function NotificationBanner() {
  const [noti, setNoti] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get('/notifications')
      .then(res => {
        if (Array.isArray(res.data)) setNoti(res.data);
        else if (Array.isArray(res.data.notifications)) setNoti(res.data.notifications);
        else setNoti([]);
        setError(null);
      })
      .catch(() => setError('Không thể tải thông báo.'));
  }, []);

  if (error) {
    return (
      <Stack spacing={1} sx={{ mb: 2, maxWidth: 800, mx: 'auto' }}>
        <Typography color="error">{error}</Typography>
      </Stack>
    );
  }

  if (!noti || noti.length === 0) return null;

  return (
    <Stack spacing={1.15} sx={{ mb: 3, maxWidth: 800, mx: 'auto' }}>
      {noti.map((n, i) => (
        <Box
          key={i}
          sx={{
            backgroundColor: 'rgba(255,255,255,0.15)',
            px: 2.3,
            py: 1,
            borderRadius: '16px',
            backdropFilter: 'blur(4px)',
            WebkitBackdropFilter: 'blur(4px)',
            cursor: 'pointer',
            ...motionHover,
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            {/* Icon trái */}
            <BlinkingIcon role="img" aria-label="left-icon">🔔</BlinkingIcon>

            {/* Nội dung giữa */}
            <Box sx={{ flex: 1, textAlign: 'center', px: 2 }}>
              {n.url ? (
                <Link
                  href={n.url}
                  target="_blank"
                  underline="none"
                  sx={{
                    fontWeight: 700,
                    fontSize: 15.7,
                    color: n.textColor || '#2577ff',
                    textShadow: n.textShadow || 'none',
                    transition: 'all .18s cubic-bezier(.4,0,.2,1)',
                    letterSpacing: 0.13,
                    wordBreak: 'break-word',
                    whiteSpace: 'normal',
                    '&:hover': {
                      color: n.textHoverColor || '#CC00FF',
                      textDecoration: 'underline',
                      textUnderlineOffset: '3px',
                      filter: 'drop-shadow(0 1.2px 6px #ffd54f60)'
                    }
                  }}
                >
                  {n.title} {n.content ? ` - ${n.content}` : ''}
                </Link>
              ) : (
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 15.7,
                    color: n.textColor || '#2577ff',
                    letterSpacing: 0.12,
                    wordBreak: 'break-word',
                    whiteSpace: 'normal'
                  }}
                >
                  {n.title} {n.content ? ` - ${n.content}` : ''}
                </Typography>
              )}
            </Box>

            {/* Icon phải */}
            <BlinkingIcon role="img" aria-label="right-icon">🔔</BlinkingIcon>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
}
